module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_join", [["div",{"class":"join-wrapper"},[["div",{"class":"decoration vert top left"}],["div",{"class":"decoration vert top right"}],["div",{"class":"decoration vert bottom left"}],["div",{"class":"decoration vert bottom right"}],["div",{"class":"decoration hor top"}],["div",{"class":"decoration hor bottom"}],["div",{"class":"join-bg-shader","id":"container"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/layout/join.tpl
// module id = 1055
// module chunks = 4